import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  stepConnectPlatforms: {
    id: "funding-application: connections and data step",
    defaultMessage: "Connections & data",
  },
  stepCreateAccount: {
    id: "funding-application: create account step",
    defaultMessage: "Create account",
  },
  stepFundingReview: {
    id: "funding-application: application review step",
    defaultMessage: "Application review",
  },
  stepGetFunded: {
    id: "funding-application: get funded step",
    defaultMessage: "Get funded",
  },
  stepVerifyBusiness: {
    id: "funding-application: verify business step",
    defaultMessage: "Verify your business",
  },
  yourFundingRequestTitle: {
    id: "funding-application: your funding request title",
    defaultMessage: "Your Funding Request",
  },
});
